(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3680],{

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 46118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-smooth-horizontal-scroll/dist/index.js
var dist = __webpack_require__(36319);
// EXTERNAL MODULE: ./components/styleguide/Carousel/carousel.module.scss
var carousel_module = __webpack_require__(67227);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Carousel/Carousel.tsx









var BrandsModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(535), __webpack_require__.e(1085)]).then(__webpack_require__.bind(__webpack_require__, 11085));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11085)
            ];
        }
    },
    ssr: false
});
var Carousel = function(param) {
    var children = param.children, scrollValue = param.scrollValue, moreLink = param.moreLink, moreLabel = param.moreLabel, sectionName = param.sectionName, header = param.header, onCustomButtonClick = param.onCustomButtonClick, _className = param.className, className = _className === void 0 ? "" : _className, _carouselClass = param.carouselClass, carouselClass = _carouselClass === void 0 ? "" : _carouselClass, _width = param.width, width = _width === void 0 ? "fixed" : _width, _overwriteMoreLabel = param.overwriteMoreLabel, overwriteMoreLabel = _overwriteMoreLabel === void 0 ? false : _overwriteMoreLabel, _showControls = param.showControls, showControls = _showControls === void 0 ? true : _showControls, _triggerScrollUpdate = param.triggerScrollUpdate, triggerScrollUpdate = _triggerScrollUpdate === void 0 ? false : _triggerScrollUpdate, _showMoreButton = param.showMoreButton, showMoreButton = _showMoreButton === void 0 ? true : _showMoreButton;
    var ref = (0,dist/* default */.Z)(), scrollContainerRef = ref.scrollContainerRef, handleScroll = ref.handleScroll, scrollTo = ref.scrollTo, isAtStart = ref.isAtStart, isAtEnd = ref.isAtEnd;
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleScroll);
        return function() {
            return window.removeEventListener("resize", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react.useEffect)(function() {
        // "jolts" slider to recalculate end and start boolean values
        var refresh = function() {
            return scrollTo(-100);
        };
        var scrollElement = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;
        scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener("load", refresh);
        return function() {
            return scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.removeEventListener("load", refresh);
        };
    }, [
        handleScroll,
        scrollContainerRef,
        scrollTo
    ]);
    (0,react.useEffect)(function() {
        handleScroll();
    }, [
        triggerScrollUpdate,
        handleScroll
    ]);
    var onBrandsMoreClick = function() {
        esm/* default.show */.ZP.show(BrandsModal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section-".concat(sectionName, " ").concat((carousel_module_default()).container, " ").concat(className),
        "data-width": width,
        "data-section-name": sectionName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((carousel_module_default()).top, " ").concat(!header ? (carousel_module_default())["no-header"] : ""),
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (carousel_module_default()).title,
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "buttons ".concat((carousel_module_default())["button-group"]),
                        children: [
                            showMoreButton && (sectionName === "brands" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onBrandsMoreClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "More"
                            }) : sectionName === "snaps" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onCustomButtonClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "I'm not interested"
                            }) : moreLink && moreLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* InternalLink */.h, {
                                href: moreLink,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                hasPadding: true,
                                hasBackground: true,
                                children: [
                                    overwriteMoreLabel ? moreLabel : "More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "sr-only",
                                        children: [
                                            " ",
                                            moreLabel
                                        ]
                                    })
                                ]
                            })),
                            showControls && !(isAtStart && isAtEnd) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (carousel_module_default()).controls,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-left"], " ").concat(isAtStart ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronLeft",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(-scrollValue);
                                            },
                                            disabled: isAtStart
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-right"], " ").concat(isAtEnd ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronRight",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(scrollValue);
                                            },
                                            disabled: isAtEnd
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((carousel_module_default()).carousel, " ").concat(carouselClass),
                onScroll: handleScroll,
                ref: scrollContainerRef,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Carousel/index.ts



/***/ }),

/***/ 8947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ RecentlyViewed; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Card/Vehicle/VehicleCard.tsx
var VehicleCard = __webpack_require__(63052);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/RecentlyViewed/RecentlyViewed.tsx






var RecentlyViewed = function(param) {
    var isVans = param.isVans;
    var ref = (0,react.useState)([]), recentlyViewed = ref[0], setRecentlyViewed = ref[1];
    (0,react.useEffect)(function() {
        if ((0,system/* storageAvailable */.oZ)("localStorage")) {
            var storedData = localStorage.getItem(isVans ? constants/* constants.localStorageKey.recentlyViewedVans */._G.localStorageKey.recentlyViewedVans : constants/* constants.localStorageKey.recentlyViewedCars */._G.localStorageKey.recentlyViewedCars);
            setRecentlyViewed(storedData ? JSON.parse(storedData).reverse() : []);
        } else {
            setRecentlyViewed([]);
        }
    }, [
        isVans
    ]);
    if (recentlyViewed.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            children: "Still interested?"
        }),
        scrollValue: 408,
        showMoreButton: false,
        sectionName: "recently-viewed",
        children: recentlyViewed.slice(0, 12).map(function(deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard/* VehicleCard */.U, {
                deal: deal,
                type: "recently-viewed"
            }, deal.vehiclePrice.id);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/RecentlyViewed/index.ts



/***/ }),

/***/ 24778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ DEALS_UNDER_300; },
  "CD": function() { return /* reexport */ NO_DEPOSIT_DEALS; },
  "UI": function() { return /* reexport */ TopDeals; }
});

// UNUSED EXPORTS: ALL_DEALS

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/Card/Vehicle/VehicleCard.tsx
var VehicleCard = __webpack_require__(63052);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/TopDeals/TopDeals.tsx



var DEALS_UNDER_300 = "under-350";
var NO_DEPOSIT_DEALS = "no-deposit";
var ALL_DEALS = "all";
var TopDeals = function(param) {
    var isVans = param.isVans, dealList = param.dealList, _type = param.type, type = _type === void 0 ? ALL_DEALS : _type;
    if (!dealList) {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Picked by Luis"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: type === NO_DEPOSIT_DEALS ? "No desposit ".concat(isVans ? "van" : "car", " leasing") : type === DEALS_UNDER_300 ? "".concat(isVans ? "Van" : "Car", " leasing for under \xa3300/pm") : "Today's top ".concat(isVans ? "van" : "car", " lease deals")
                })
            ]
        }),
        scrollValue: 408,
        moreLink: type === NO_DEPOSIT_DEALS ? "".concat(isVans ? "van" : "car", "-leasing/no-deposit") : type === DEALS_UNDER_300 ? "".concat(isVans ? "van" : "car", "-leasing/budget/300") : "".concat(isVans ? "van" : "car", "-leasing/search"),
        moreLabel: "".concat(type === DEALS_UNDER_300 ? "cheap" : type === NO_DEPOSIT_DEALS ? "no deposit" : "of the best", " deals"),
        sectionName: "".concat(type === DEALS_UNDER_300 ? "cheapest" : type === NO_DEPOSIT_DEALS ? "no-deposit" : "best", "-deals"),
        children: dealList.map(function(deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard/* VehicleCard */.U, {
                deal: deal,
                type: "carousel"
            }, deal.vehiclePrice.id);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/TopDeals/index.ts



/***/ }),

/***/ 27838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ LocoScore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/loco-score.module.scss
var loco_score_module = __webpack_require__(53644);
var loco_score_module_default = /*#__PURE__*/__webpack_require__.n(loco_score_module);
;// CONCATENATED MODULE: ./components/styleguide/LocoScore/LocoScore.tsx



var LocoScore = function(param) {
    var rating = param.rating, _className = param.className, className = _className === void 0 ? "" : _className, _iconOnly = param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline;
    var ref = (0,react.useState)("0, 100"), strokeDasharray = ref[0], setStrokeDasharray = ref[1];
    var ref1 = (0,react.useState)("#FFCC00"), colour = ref1[0], setColour = ref1[1];
    var ref2 = (0,react.useState)(0), currentRating = ref2[0], setCurrentRating = ref2[1];
    var PERFECT_SCORE = 73;
    (0,react.useEffect)(function() {
        // Setting up the dynamic keyframe end value when the component mounts or `rating` changes
        if (currentRating !== rating) {
            var animationCSS = "".concat(rating / 100 * PERFECT_SCORE, ", 100");
            var animation = setTimeout(function() {
                setStrokeDasharray(animationCSS);
                setColour(rating >= 80 ? "#FF2D55" : rating > 70 ? "#F15A24" : "#FFCC00");
                setCurrentRating(rating);
            }, 5);
            return function() {
                clearTimeout(animation);
            };
        }
    }, [
        currentRating,
        rating
    ]);
    var getDescriptionFromRating = function() {
        if (rating >= 90) {
            return "Amazing value";
        } else if (rating >= 80) {
            return "Great value";
        } else if (rating >= 70) {
            return "Fair value";
        } else {
            return "Low value";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((loco_score_module_default()).container, " ").concat(className),
        "data-is-inline": isInline,
        "data-icon-only": iconOnly,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    position: "relative",
                    display: "grid",
                    placeItems: "center",
                    height: 34,
                    width: 34
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        className: (loco_score_module_default()).ring,
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 4
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: colour,
                            style: {
                                strokeDasharray: strokeDasharray
                            },
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: "#E5E5EA",
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (loco_score_module_default()).score,
                        style: {
                            color: colour
                        },
                        children: rating
                    }),
                    rating > 90 && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "14",
                        height: "13",
                        viewBox: "0 0 14 13",
                        fill: "none",
                        className: (loco_score_module_default()).flame,
                        style: {
                            position: "absolute",
                            bottom: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.19652 8.10588C5.53809 8.10588 5.86567 7.9702 6.10719 7.72867C6.34872 7.48715 6.4844 7.15957 6.4844 6.818C6.4844 6.1071 6.22683 5.7877 5.96925 5.27255C5.41701 4.16858 5.85386 3.18413 6.99955 2.18164C7.25713 3.46952 8.02986 4.70588 9.06016 5.53013C10.0905 6.35437 10.6056 7.33316 10.6056 8.36346C10.6056 8.83701 10.5123 9.30593 10.3311 9.74344C10.1499 10.1809 9.88428 10.5785 9.54942 10.9133C9.21457 11.2482 8.81704 11.5138 8.37953 11.695C7.94203 11.8762 7.47311 11.9695 6.99955 11.9695C6.526 11.9695 6.05708 11.8762 5.61957 11.695C5.18207 11.5138 4.78454 11.2482 4.44968 10.9133C4.11483 10.5785 3.84921 10.1809 3.66799 9.74344C3.48677 9.30593 3.39349 8.83701 3.39349 8.36346C3.39349 7.76949 3.61655 7.1817 3.90865 6.818C3.90865 7.15957 4.04433 7.48715 4.28586 7.72867C4.52738 7.9702 4.85496 8.10588 5.19652 8.10588Z",
                            fill: "#FF2D55"
                        })
                    })
                ]
            }),
            !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (loco_score_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).title,
                        children: "LocoScore"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).description,
                        children: getDescriptionFromRating()
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/LocoScore/index.ts



/***/ }),

/***/ 87319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ TrustpilotStarWidget; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/styleguide/TrustpilotStarWidget/trustpilot.module.scss
var trustpilot_module = __webpack_require__(14667);
var trustpilot_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/styleguide/TrustpilotStarWidget/TrustpilotStarWidget.tsx






var TrustpilotStarWidget = function(param) {
    var _theme = param.theme, theme = _theme === void 0 ? "light" : _theme;
    var widgetRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.disconnect();
            }
        }, {
            rootMargin: "0px 0px 100px 0px"
        });
        if (widgetRef.current) {
            observer.observe(widgetRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isVisible && window.Trustpilot && widgetRef.current) {
            window.Trustpilot.loadFromElement(widgetRef.current);
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: widgetRef,
        className: (trustpilot_module_default()).trustpilot,
        children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    strategy: "lazyOnload"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: widgetRef,
                    className: "trustpilot-widget",
                    "data-locale": "en-GB",
                    "data-template-id": constants/* constants.trustpilot.templates.MICRO_STAR.id */._G.trustpilot.templates.MICRO_STAR.id,
                    "data-businessunit-id": constants/* constants.trustpilot.businessUnitId */._G.trustpilot.businessUnitId,
                    "data-style-height": constants/* constants.trustpilot.templates.MICRO_STAR.height */._G.trustpilot.templates.MICRO_STAR.height,
                    "data-style-width": "100%",
                    "data-theme": theme
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/TrustpilotStarWidget/index.ts



/***/ }),

/***/ 52733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ VehicleImage; },
  "C": function() { return /* reexport */ VehicleImageWithGallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/vehicle-image.module.scss
var vehicle_image_module = __webpack_require__(80001);
var vehicle_image_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_image_module);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImage.tsx




var VehicleImage = function(param) {
    var alt = param.alt, height = param.height, width = param.width, imagePath = param.imagePath, backupImagePath = param.backupImagePath, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        ".concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && imagePath ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(!imagePath ? (vehicle_image_module_default())["padded-image"] : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: imagePath ? (0,vehicle/* getGalleryImage */.Dq)(imagePath) : (0,vehicle/* getVehicleHeroImage */.Nk)(backupImagePath),
            alt: alt,
            height: height,
            width: width,
            priority: priority,
            quality: quality,
            layout: layout,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            className: className,
            unoptimized: unoptimized
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImageWithGallery.tsx








var VehicleImageWithGallery = function(param) {
    var alt = param.alt, height = param.height, width = param.width, images = param.images, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _showDots = param.showDots, showDots = _showDots === void 0 ? true : _showDots, _alignDots = param.alignDots, alignDots = _alignDots === void 0 ? "center" : _alignDots, onChangeIndex = param.onChangeIndex;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useRef)(null);
    var onChangeCurrentIndex = function(index) {
        if (onChangeIndex) {
            onChangeIndex(index);
        }
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_image_module_default()).wrapper,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: (vehicle_image_module_default()).carousel,
                onScroll: function(e) {
                    var target = e.target;
                    var calculation = Math.floor(target.scrollLeft / target.children[0].clientWidth);
                    onChangeCurrentIndex(calculation < 0 ? 0 : calculation);
                },
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                        triggerOnce: true,
                        duration: 1000,
                        className: (vehicle_image_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-index": index,
                            className: "".concat((vehicle_image_module_default()).content, " ").concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && image.path ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(type === "SPEC" ? (vehicle_image_module_default())["spec-image"] : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,vehicle/* getGalleryImage */.Dq)(image.path),
                                alt: alt,
                                height: height,
                                width: width,
                                quality: quality,
                                layout: layout,
                                placeholder: placeholder,
                                blurDataURL: blurDataURL,
                                className: className,
                                unoptimized: unoptimized
                            })
                        })
                    }, image.id);
                })
            }),
            showDots && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (vehicle_image_module_default()).dots,
                "data-alignment": alignDots,
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((vehicle_image_module_default()).dot).concat(currentIndex === index ? " " + (vehicle_image_module_default()).active : "").concat(Math.abs(currentIndex - index) > 2 ? Math.abs(currentIndex - index) >= 4 ? " " + (vehicle_image_module_default())["too-far"] : " " + (vehicle_image_module_default()).far : Math.abs(currentIndex - index) > 1 ? " " + (vehicle_image_module_default()).close : "")
                    }, image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (vehicle_image_module_default()).arrows,
                "data-navigation-position": currentIndex === 0 ? "start" : currentIndex === images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).length - 1 ? "end" : "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft - ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        icon: "ChevronLeft",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled,
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft + ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark,
                        icon: "ChevronRight",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/index.ts




/***/ }),

/***/ 8465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ HeroBackground; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/views/HomePage/HeroBackground/hero-background.module.scss
var hero_background_module = __webpack_require__(31072);
var hero_background_module_default = /*#__PURE__*/__webpack_require__.n(hero_background_module);
// EXTERNAL MODULE: ./components/styleguide/Header/index.ts + 9 modules
var Header = __webpack_require__(638);
// EXTERNAL MODULE: ./components/styleguide/TrustpilotStarWidget/index.ts + 1 modules
var TrustpilotStarWidget = __webpack_require__(87319);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/views/HomePage/HeroBackground/HeroBackground.js








var HeroBackground = function(param) {
    var children = param.children, isVans = param.isVans;
    var isDesktop = (0,react_responsive.useMediaQuery)({
        minWidth: 1600
    });
    var ref = (0,react.useState)(false), useBig = ref[0], setUseBig = ref[1];
    (0,react.useEffect)(function() {
        if (isDesktop) {
            setUseBig(true);
        } else {
            setUseBig(false);
        }
    }, [
        isDesktop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((hero_background_module_default()).main, " ").concat(isVans ? (hero_background_module_default())["is-vans"] : (hero_background_module_default())["is-cars"]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (hero_background_module_default()).top,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/homepage/top-dash.svg"),
                            alt: "Top of a dashboard",
                            layout: "fill",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                        theme: useBig ? "dark" : "light",
                        backgroundColor: "transparent",
                        width: "wrapper"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (hero_background_module_default()).background,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        className: (hero_background_module_default()).confetti,
                        width: "702",
                        height: "418",
                        viewBox: "0 0 702 418",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M537.5 19.6554C568.438 -8.4696 592.613 13.9703 597.312 23.9679C616.026 59.4208 587.75 91.0928 569.75 82.5171C549.409 70.7737 576.875 12.6538 620.188 22.2163C668.018 35.6138 654.652 113.177 628.062 103.216C596.209 91.2832 663.93 12.8568 695.562 59.4054",
                                stroke: "#FFCC00",
                                strokeWidth: "12",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M106.577 269.212C85.7763 263.907 74.4715 262.373 57.4589 259.39C67.5693 278.695 72.7935 289.5 80.8665 308.675C62.3696 307.174 50.4262 306.003 33.9068 299.59C39.1416 317.849 45.8847 328.781 56.5117 347.982C38.7862 345.486 26.9064 344.044 9.89817 343.705C19.8089 368.307 25.0328 382.201 29.4141 408.501",
                                stroke: "#FFCC00",
                                strokeWidth: "12",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M39.0006 92.1806C47.4025 77.3851 55.3079 70.974 77.2623 64.1516",
                                stroke: "#FF2D55",
                                strokeWidth: "12",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M577.783 243.385C589.178 256.019 598.281 260.574 621.19 262.5",
                                stroke: "#FF2D55",
                                strokeWidth: "12",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (hero_background_module_default()).widget,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustpilotStarWidget/* TrustpilotStarWidget */.$, {
                    theme: "light"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/HomePage/HeroBackground/index.js



/***/ }),

/***/ 17836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ Search; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/views/HomePage/Search/search.module.scss
var search_module = __webpack_require__(9945);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/styleguide/TrustpilotStarWidget/index.ts + 1 modules
var TrustpilotStarWidget = __webpack_require__(87319);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var search = __webpack_require__(29109);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/HomePage/Search/Search.js
















var MediaQuery = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 1852, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1852)
            ];
        }
    },
    ssr: false
});
var Animation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260), __webpack_require__.e(90)]).then(__webpack_require__.bind(__webpack_require__, 90090));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90090)
            ];
        }
    },
    ssr: false
});
var savedSearchReferences = [
    {
        ref: "4d56b4a8c34e632f514f4fa957ad65d8",
        label: "Under \xa3250/pm"
    },
    {
        ref: "b960d43d5d3c027d4926af1a646c536f",
        label: "Family cars"
    },
    {
        ref: "ddacda9c0bcc3b550c12c696e7049b18",
        label: "Electric cars"
    }, 
];
var Search = function(param) {
    var isVans = param.isVans, children = param.children, _popularSearchesVisibility = param.popularSearchesVisibility, popularSearchesVisibility = _popularSearchesVisibility === void 0 ? "always" : _popularSearchesVisibility;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    (0,react.useEffect)(function() {
        dispatch((0,search/* resetSearchState */.W5)());
    }, [
        dispatch
    ]);
    var onLinkClick = function(item) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "homepage-search-chip",
            label: item.label,
            experimentGroup: experimentGroup
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (search_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    "Your ",
                                    isVans ? "van" : "car",
                                    " leasing compadre"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Compare millions of deals from over 80 providers."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            children,
                            !isVans && popularSearchesVisibility !== "never" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery, {
                                minWidth: 768,
                                children: function(matches) {
                                    return matches && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (search_module_default()).pills,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (search_module_default()).pills__title,
                                                children: [
                                                    "Popular",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery, {
                                                        minWidth: 992,
                                                        children: function(matches) {
                                                            return matches ? " searches" : "";
                                                        }
                                                    }),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: (search_module_default()).pills__container,
                                                children: savedSearchReferences.map(function(item, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                            hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                                                            theme: system/* Theme.dark */.Q2.dark,
                                                            size: system/* Size.Medium */.$u.Medium,
                                                            hasUnderline: true,
                                                            onClick: function() {
                                                                return onLinkClick(item);
                                                            },
                                                            href: "/car-leasing/search/".concat(item.ref),
                                                            children: item.label
                                                        })
                                                    }, idx);
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_module_default())["rear-mirror"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/homepage/rear-mirror.svg"),
                    height: "148",
                    width: "349",
                    alt: "rear view mirror",
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                triggerOnce: true,
                className: (search_module_default()).animation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_module_default()).extras,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (search_module_default()).widget,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustpilotStarWidget/* TrustpilotStarWidget */.$, {
                        theme: "dark"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/HomePage/Search/index.js



/***/ }),

/***/ 67227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__QBa3N","carousel":"carousel_carousel___HIyX","top":"carousel_top__Ejz_R","button-group":"carousel_button-group__KuHj8","controls":"carousel_controls__l6IQd","button-left":"carousel_button-left__dzsFP","button-right":"carousel_button-right__mxuOU","disabled":"carousel_disabled__DhoqA","no-header":"carousel_no-header__qLh0q","phAnimation":"carousel_phAnimation__PK7Jm"};

/***/ }),

/***/ 53644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"score":"loco-score_score___FxZc","ring":"loco-score_ring__zuCKC","container":"loco-score_container__p90CW","text":"loco-score_text__w_aMB","title":"loco-score_title__zoTzI","description":"loco-score_description__MfcQu","phAnimation":"loco-score_phAnimation__ElO02"};

/***/ }),

/***/ 14667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilot":"trustpilot_trustpilot__1hPn1","phAnimation":"trustpilot_phAnimation__JhCx9"};

/***/ }),

/***/ 80001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reverse-image":"vehicle-image_reverse-image__uOgl_","padded-image":"vehicle-image_padded-image__sESfX","wrapper":"vehicle-image_wrapper__zluzR","arrows":"vehicle-image_arrows__4kG9G","dots":"vehicle-image_dots__RtU0B","dot":"vehicle-image_dot__bxknn","close":"vehicle-image_close__agwhd","far":"vehicle-image_far___i7DM","too-far":"vehicle-image_too-far__Mglyo","active":"vehicle-image_active__a6CKC","carousel":"vehicle-image_carousel__kVC1q","item":"vehicle-image_item__XBP0m","content":"vehicle-image_content__qHmo1","spec-image":"vehicle-image_spec-image__EEsLS","phAnimation":"vehicle-image_phAnimation__X2gd8"};

/***/ }),

/***/ 31072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"hero-background_main__21k_q","is-vans":"hero-background_is-vans__yPCAl","is-cars":"hero-background_is-cars__hHL2O","background":"hero-background_background__T9FzK","confetti":"hero-background_confetti__SlZBS","top":"hero-background_top__YOP6X","full":"hero-background_full__j7z7Y","widget":"hero-background_widget__QysTw","phAnimation":"hero-background_phAnimation__XkcDA"};

/***/ }),

/***/ 9945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__75s90","rear-mirror":"search_rear-mirror__zR__t","content":"search_content__jbZW8","animation":"search_animation__AHT9a","extras":"search_extras__ciKS5","widget":"search_widget__fkKCd","bottom":"search_bottom__rzjQO","title":"search_title__x_FtQ","pills":"search_pills__Vt0sz","pills__title":"search_pills__title__xW_sW","pills__container":"search_pills__container__wbNYd","phAnimation":"search_phAnimation__0Pn9g"};

/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ }),

/***/ 36319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
function ___$insertStyle(e){if(e&&"undefined"!=typeof window){var t=document.createElement("style");return t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t),e}}__webpack_unused_export__ = ({value:!0});var react=__webpack_require__(67294),useSmoothHorizontalScroll=function(){var l=react.useRef(null),e=react.useState(!0),t=e[0],n=e[1],r=react.useState(!1),o=r[0],c=r[1];react.useEffect(function(){l.current&&c(l.current.scrollWidth===l.current.offsetWidth)},[l]);return{scrollContainerRef:l,handleScroll:function(){var e,t,r,o;l.current&&(n(0===(null===(e=l.current)||void 0===e?void 0:e.scrollLeft)),c(Math.floor((null===(t=l.current)||void 0===t?void 0:t.scrollWidth)-(null===(r=l.current)||void 0===r?void 0:r.scrollLeft))<=(null===(o=l.current)||void 0===o?void 0:o.offsetWidth)))},scrollTo:function(e){var t,r;null!==(t=l.current)&&void 0!==t&&t.scrollTo({left:(null===(r=l.current)||void 0===r?void 0:r.scrollLeft)+e,behavior:"smooth"})},isAtStart:t,isAtEnd:o}};exports.Z=useSmoothHorizontalScroll;
//# sourceMappingURL=index.js.map


/***/ })

}]);